import { Form, Grid, Input } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import HomesGlobeSmallIcon from "@/assets/brand/HomesGlobeSmallIcon";
import Button from "@/common/atoms/Button";
import { ErrorAlert } from "@/common";
import { forgotPasswordRequest } from "../duck/auth";
import AuthHeading from "../common/AuthHeading";
import BrnadInfoAuth from "../common/BrandInfoAuth";
import "./ForgotPasswordModal.scss";

const ForgotPasswordComponent = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const isMobile = !screens.lg;

  const { forgotLoading, error } = useSelector(
    (state) => state.auth,
    shallowEqual
  );
  const onFinish = (values) => {
    dispatch(forgotPasswordRequest(values));
  };

  return (
    <div className="flex gap-1 relative forgot-password-modal">
      <div className="bg-white rounded-lg mt-[40px] p-8 flex-[2] relative forgot-password-modal overflow-hidden flex flex-col justify-evenly">
        <HomesGlobeSmallIcon />
        <AuthHeading
          title={t("forgot.forgotPassword")}
          subTitle={t("forgot.enterEmailInstruction")}
        />
        {/* FORM */}
        {error && <ErrorAlert error={error} />}
        <Form
          form={form}
          name="forgotPassword"
          onFinish={onFinish}
          layout="vertical">
          <Form.Item
            name="email"
            label={
              <span className="text-secondary font-poppins">
                {t("common.email")}
              </span>
            }
            rules={[
              { required: true, message: t("common.emailRequired") },
              { type: "email", message: t("common.emailInvalid") }
            ]}>
            <Input
              placeholder={t("common.enterEmail")}
              className="rounded-md h-12 flex items-center justify-center"
            />
          </Form.Item>

          <Form.Item>
            <Button
              loading={forgotLoading}
              htmlType="submit"
              className="w-full my-4 p-4 h-[37px]">
              {t("common.submit")}
            </Button>
          </Form.Item>
        </Form>
        {/* FORM */}
      </div>
      {!isMobile && (
        <div className="flex-[1.5]  h-auto">
          <BrnadInfoAuth
            title={t("brandInfoAuth.title")}
            subTitle1={t("brandInfoAuth.subTitle1")}
            subTitle2={t("brandInfoAuth.subTitle2")}
            showwImage={false}
          />
        </div>
      )}
    </div>
  );
};

export default ForgotPasswordComponent;
